<template>
  <div>
    <div class="text-right my-3">
      <router-link tag="button" class="btn btn-outline-secondary" to="/admin/column/write">컬럼 추가하기</router-link>
    </div>
    <table class="table mb-5">
      <thead>
        <tr>
          <th scope="col" style="width: 100px;" class="text-center">#</th>
          <th scope="col">제목</th>
          <th scope="col" style="width: 70px;" class="text-center">공개</th>
          <th scope="col" style="width: 100px;" class="text-center">작성일</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="list.length === 0">
          <tr>
            <td class="text-center vh-100" colspan="3">컬럼이 없습니다.</td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="(item, idx) in list" :key="idx">
            <th scope="row" class="text-center">{{item.id}}</th>
            <td>
              <router-link :to="{name:'adminColumnView', params: { id: item.id}}">
                {{item.title | normalize}}
              </router-link>
            </td>
            <td class="text-center">{{ item.status ? '공개' : '비공개'}}</td>
            <td class="text-center"><small>{{item.createAt | moment('YYYY-MM-DD HH:mm:ss')}}</small></td>
          </tr>
        </template>
      </tbody>
    </table>

    <pagination :pageable="{ name: 'adminColumnList', current: currentPage, total: totalPage, size: size, }" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import pagination from '@/mixins/pagination';

export default {
  name: 'AdminColumnList',
  components: { Pagination },
  mixins: [pagination],
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getList(to.query.page, to.query.size);
    next();
  },
  methods: {
    getList(page = 0, size = 10) {
      this.$axios.get('/admin/media/column', { params: { page, size } })
        .then(({ data }) => {
          this.list = data.content;
          this.total = data.totalElements;
          this.pages = data.totalPages;
          this.totalPage = data.totalPages;
          this.currentPage = data.number;
          this.size = data.size;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>

</style>
